<template>
  <div class="msg-card">
      <div class="sys-img"><img :src="uinInfo.str_avatar"></div>
      <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    uinInfo: Object,
    text: String,
  },
};
</script>

<style lang="less" scoped>
.msg-card {
  .sys-img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    border: 2px solid #fff;
    background: #fff;
    position: relative;
    margin: auto;
    margin-bottom: -20px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      border: none;
      vertical-align: bottom;
    }
  }
  .text {
    width: 186px;
    background: #fff;
    border-radius: 6px;
    padding: 25px 20px 15px;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #78849e;
    margin: auto;
    box-shadow: 0 2px 10px 0 rgba(197,204,219,.4);
    word-wrap: break-word;
  }
}
.pc.pc-not-frame {
  .msg-card {
    .sys-img {
      position: relative;
      height: 56px;
      width: 56px;
      margin-bottom: -34px;
      overflow: visible;
      border: none;
      img {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: inherit;
      }
    }
    .sys-img::before {
      content: "";
      width: 100%;
      height: 50%;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 64px 64px 0 0;
      background-color: transparent;
      box-shadow: 0px 2px 10px 0px rgba(197, 204, 219, 0.4);
    }
    .text {
      width: auto;
      max-width: 280px;
      padding: 42px 20px 10px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
